import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import './style.css'
import NijjarLegacy from './views/nijjar-legacy'

const App = () => {
  return (
    <Router>
      <div>
        <Route component={NijjarLegacy} exact path="/" />
      </div>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
